import React, { ReactNode } from 'react';

import { Box } from '@mui/material';

import Breadcrumbs from '../common/Breadcrumbs';
import ProgressSpinner from '../common/ProgressSpinner';


interface PrimaryLayoutProps {
    children: ReactNode;
    transparentLoading?: boolean;
    opaqueLoading?: boolean;
    showBreadcrumb?: boolean;
}


const PrimaryLayout: React.FC<PrimaryLayoutProps> = ({
    transparentLoading,
    opaqueLoading,
    children,
    showBreadcrumb = true,
}) => {

    if (opaqueLoading) {
        return <ProgressSpinner />;
    }

    return (
        <Box>
            {showBreadcrumb && <Breadcrumbs />}
            {transparentLoading && <ProgressSpinner />}

            <Box>{children}</Box>
        </Box>
    )
}

export default PrimaryLayout